import React, { Component } from 'react';

import getMyMap, {createCommuneBordersLayer, createResidentialAreasMassLayer, createAreasLayer, createNamesLayer,
  createFlowsLayer, getLegendFlows, getLegend} from '../b-LeafletMap/leaflet_map';

import LegendResidentialArea from '../b-LeafletMap/Legend/LegendResidentialArea';
import LegendClusterArea from '../b-LeafletMap/Legend/LegendClusterArea';
import LegendValuesFlows from '../b-LeafletMap/Legend/LegendValuesFlows';

class DestinationsWork extends React.Component {
  componentDidMount() {
    /* COMMUNES */
    var communes = this.props.territory.communes;
    var communes_coords = communes.map((c) => c.center);
    var communes_names = communes.map((c) => c.name);

    /* RESIDENTIAL */
    var residential_areas = [];
    this.props.territory.communes.map((c) => residential_areas = residential_areas.concat(c.residential_areas));
    var ra_population = residential_areas.map((ra) => ra.population)
    var ra_labels = residential_areas.map((ra)=> ra.name + " - " + ra.population + " hab")


    /* WORK AREAS */
    var commutes = this.props.territory.commuter_matrix
    var commutes_values_name = Object.values(commutes).map((c) => Object.values(c)[0])

    var work_areas = this.props.territory.areas_by_reason[0].areas.filter((wa)=>Object.values(commutes[wa.id]).reduce((a, b) => a + b, 0)>50);
    var work_areas_coords = work_areas.map((wa) => wa.coords)
    var work_areas_names_coords = work_areas.map((wa) => [wa.coords[0] + 0.0075, wa.coords[1]])
    var work_areas_masses = work_areas.map((wa) => Object.values(commutes[wa.id]).reduce((a, b) => a + b, 0));
    var work_areas_labels = work_areas.map((wa) => '<span class="small-text">' + wa.name + "</span></br>" +
                                                   Object.values(commutes[wa.id]).reduce((a, b) => a + b, 0))


    /* FLOWS */
    var work_travels_flows = this.props.territory.work_travels_flows;



    // --- init map
    var mymap = getMyMap(this.props.id, true, 0.3);
    const info = document.getElementById("info");

    // --- create layers
    var communes_layer = createCommuneBordersLayer(mymap, communes)
    createResidentialAreasMassLayer(mymap, residential_areas, null, null);
    createFlowsLayer(mymap, work_travels_flows, info);
    createAreasLayer(mymap, work_areas, commutes, info);
    createNamesLayer(mymap, work_areas_names_coords, work_areas_labels);

    // --- center the map
    mymap.fitBounds(communes_layer.getBounds());

  }


  render() {/*
  var work_travels = this.props.territory.work_travels;
  var work_travels_flows = this.props.territory.work_travels_flows;

  var communes = this.props.territory.communes;
  var residential_areas = [];
  communes.map((c) => residential_areas = residential_areas.concat(c.residential_areas))

  var work_areas = this.props.territory.areas_by_reason[0].areas;

  var commutes = this.props.territory.commuter_matrix;*/




  var communes = this.props.territory.communes;
  var c_population =communes.map((c) => c.status.retired);

  var [colors, intervals] = getLegend(c_population);


  const flow_values = this.props.territory.work_travels_flows.map((f) => f.id);
  var [colors_f, intervals_f] = getLegendFlows(flow_values);

    return(

      <div className="row align-items-stretch">
          <div className="col-9">
            <div style={{height: "600px"}} id={this.props.id}></div>
          </div>

          <div className="col-3 d-flex flex-column">
            <div className="row h-100">
              <div className="col">
                <div id="info"><p>Passer la souris sur les flux et lieux pour des informations spécifiques.</p></div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <LegendResidentialArea grey={true}/>
                <LegendClusterArea label="Communes de destination" sublabel="nombre d'actifs vers la commune"/>
                <div className="mt-5"></div>
                <LegendValuesFlows intervals={intervals_f} colors={colors_f}/>
              </div>
            </div>
          </div>
      </div>

    )
  }
}

export default DestinationsWork;
